import { EmojiCategory } from '../types';

export const emojiLibrary: EmojiCategory[] = [
  {
    name: "Self Energy",
    emojis: [
      { emoji: "😊", keywords: ["smile", "happy", "self"], color: "yellow", description: "Warm, welcoming Self" },
      { emoji: "🥰", keywords: ["loving", "heart", "self"], color: "red", description: "Loving, compassionate Self" },
      { emoji: "😌", keywords: ["relieved", "peaceful", "self"], color: "green", description: "Peaceful, calm Self" },
      { emoji: "😇", keywords: ["innocent", "pure", "self"], color: "yellow", description: "Pure, innocent Self" },
      { emoji: "🤗", keywords: ["hugging", "embracing", "self"], color: "orange", description: "Embracing, accepting Self" },
      { emoji: "😃", keywords: ["joyful", "radiant", "self"], color: "yellow", description: "Joyful, radiant Self" },
      { emoji: "😉", keywords: ["winking", "playful", "self"], color: "blue", description: "Playful, light Self" },
      { emoji: "🙂", keywords: ["gentle", "subtle", "self"], color: "green", description: "Gentle, subtle Self" }
    ]
  },
  {
    name: "Integrated Energy",
    emojis: [
      { emoji: "🥰", keywords: ["loving", "integrated", "peaceful"], color: "yellow", description: "Loving integrated part" },
      { emoji: "😌", keywords: ["content", "peaceful", "serene"], color: "green", description: "Serene integrated part" },
      { emoji: "😊", keywords: ["happy", "content", "peaceful"], color: "yellow", description: "Content integrated part" },
      { emoji: "😇", keywords: ["blessed", "pure", "integrated"], color: "blue", description: "Blessed integrated part" },
      { emoji: "😃", keywords: ["joyful", "happy", "free"], color: "orange", description: "Joyful integrated part" },
      { emoji: "🤗", keywords: ["embracing", "whole", "complete"], color: "violet", description: "Embracing integrated part" },
      { emoji: "😄", keywords: ["happy", "radiant", "bright"], color: "yellow", description: "Radiant integrated part" },
      { emoji: "☺️", keywords: ["content", "peaceful", "gentle"], color: "green", description: "Gentle integrated part" }
    ]
  },
  {
    name: "Protector Energy",
    emojis: [
      { emoji: "😠", keywords: ["angry", "guard", "protect"], color: "red", description: "Fierce protector" },
      { emoji: "🤨", keywords: ["skeptical", "suspicious"], color: "orange", description: "Cautious protector" },
      { emoji: "😤", keywords: ["determined", "strong"], color: "violet", description: "Determined protector" },
      { emoji: "🧐", keywords: ["examine", "analyze"], color: "blue", description: "Analytical protector" },
      { emoji: "😎", keywords: ["cool", "confident"], color: "indigo", description: "Confident protector" },
      { emoji: "😑", keywords: ["expressionless", "boundary"], color: "indigo", description: "Boundary-setting protector" },
      { emoji: "😒", keywords: ["unamused", "skeptical"], color: "violet", description: "Skeptical protector" },
      { emoji: "🤔", keywords: ["thinking", "evaluating"], color: "blue", description: "Evaluating protector" }
    ]
  },
  {
    name: "Exile Energy",
    emojis: [
      { emoji: "😢", keywords: ["sad", "cry"], color: "blue", description: "Sad exile" },
      { emoji: "🥺", keywords: ["pleading", "vulnerable"], color: "violet", description: "Vulnerable exile" },
      { emoji: "😔", keywords: ["pensive", "down"], color: "indigo", description: "Pensive exile" },
      { emoji: "😕", keywords: ["confused", "uncertain"], color: "green", description: "Uncertain exile" },
      { emoji: "😟", keywords: ["worried", "concerned"], color: "orange", description: "Worried exile" },
      { emoji: "😥", keywords: ["disappointed", "sad"], color: "blue", description: "Disappointed exile" },
      { emoji: "😞", keywords: ["dejected", "hurt"], color: "indigo", description: "Hurt exile" },
      { emoji: "😖", keywords: ["confounded", "frustrated"], color: "red", description: "Frustrated exile" }
    ]
  },
  {
    name: "Manager Energy",
    emojis: [
      { emoji: "🤔", keywords: ["thinking", "planning"], color: "blue", description: "Thoughtful manager" },
      { emoji: "😐", keywords: ["neutral", "control"], color: "indigo", description: "Controlled manager" },
      { emoji: "🤓", keywords: ["nerd", "detail"], color: "green", description: "Detail-oriented manager" },
      { emoji: "😤", keywords: ["determined", "focused"], color: "red", description: "Focused manager" },
      { emoji: "🧐", keywords: ["analytical", "examining"], color: "indigo", description: "Analytical manager" },
      { emoji: "😌", keywords: ["organized", "satisfied"], color: "green", description: "Organized manager" },
      { emoji: "😏", keywords: ["strategic", "planning"], color: "blue", description: "Strategic manager" },
      { emoji: "🤨", keywords: ["evaluating", "assessing"], color: "violet", description: "Evaluating manager" }
    ]
  },
  {
    name: "Rescuer Energy",
    emojis: [
      { emoji: "😰", keywords: ["anxious", "worried"], color: "blue", description: "Anxious rescuer" },
      { emoji: "😨", keywords: ["fearful", "scared"], color: "violet", description: "Fearful rescuer" },
      { emoji: "😱", keywords: ["scream", "panic"], color: "red", description: "Panicked rescuer" },
      { emoji: "😯", keywords: ["hushed", "alert"], color: "green", description: "Alert rescuer" },
      { emoji: "😦", keywords: ["frowning", "concerned"], color: "orange", description: "Concerned rescuer" },
      { emoji: "😧", keywords: ["anguished", "distressed"], color: "violet", description: "Distressed rescuer" },
      { emoji: "😮", keywords: ["open mouth", "surprise"], color: "blue", description: "Surprised rescuer" },
      { emoji: "😲", keywords: ["astonished", "shocked"], color: "indigo", description: "Shocked rescuer" }
    ]
  }
];

export const emojiColorMap: Record<string, {
  bg: string;
  border: string;
  text: string;
  hover: string;
}> = {
  red: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-800',
    hover: 'hover:bg-red-100'
  },
  orange: {
    bg: 'bg-orange-50',
    border: 'border-orange-200', 
    text: 'text-orange-800',
    hover: 'hover:bg-orange-100'
  },
  yellow: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-800',
    hover: 'hover:bg-amber-100'
  },
  green: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-800',
    hover: 'hover:bg-emerald-100'
  },
  blue: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-800',
    hover: 'hover:bg-blue-100'
  },
  indigo: {
    bg: 'bg-indigo-50',
    border: 'border-indigo-200',
    text: 'text-indigo-800',
    hover: 'hover:bg-indigo-100'
  },
  violet: {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    text: 'text-purple-800',
    hover: 'hover:bg-purple-100'
  }
};